import { Fragment, type ReactNode } from "react";

/** Render inline: `code` và **đậm**. Không dùng innerHTML — an toàn tuyệt đối. */
export function Inline({ text }: { text: string }): ReactNode {
  const parts = text.split(/(`[^`]+`|\*\*[^*]+\*\*)/g);
  return (
    <>
      {parts.map((p, i) => {
        if (p.startsWith("`") && p.endsWith("`") && p.length > 1) return <code key={i}>{p.slice(1, -1)}</code>;
        if (p.startsWith("**") && p.endsWith("**") && p.length > 3) return <strong key={i}>{p.slice(2, -2)}</strong>;
        return <Fragment key={i}>{p}</Fragment>;
      })}
    </>
  );
}

/** Đoạn văn cách nhau bởi dòng trống; các dòng bắt đầu bằng "- " thành danh sách. */
export function RichText({ text }: { text: string }) {
  const blocks = text.split(/\n\s*\n/);
  return (
    <>
      {blocks.map((block, i) => {
        const lines = block.split("\n").filter((l) => l.trim());
        if (lines.length && lines.every((l) => l.trimStart().startsWith("- "))) {
          return (
            <ul key={i}>
              {lines.map((l, j) => (
                <li key={j}><Inline text={l.trimStart().slice(2)} /></li>
              ))}
            </ul>
          );
        }
        return <p key={i}><Inline text={lines.join(" ")} /></p>;
      })}
    </>
  );
}
